export default __webpack_public_path__ + "static/media/git-intro.132c2d29.png";